import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMapPin, FiMessageSquare, FiTrendingDown, FiEyeOff } = FiIcons;

const Problem = () => {
  const problems = [
    {
      icon: FiMapPin,
      title: "Invisible in the Map Pack",
      desc: "When locals search for your services, your competitors show up in the top spots, while you're buried simply because they have clearer entity signals."
    },
    {
      icon: FiMessageSquare,
      title: "Weak Trust Signals",
      desc: "Your reviews, brand mentions, and E-E-A-T signals lack the specific proof points that Google and AI systems look for to build authority."
    },
    {
      icon: FiTrendingDown,
      title: "Stalled Growth",
      desc: "You got comfortable with old online marketing. Now, your old online growth is weakening and it's hard to recover visibility and revenue."
    },
    {
      icon: FiEyeOff,
      title: "Poor AI Readiness",
      desc: "Modern AI search tools and answer engines cannot easily validate why you are the best choice in your local market."
    }
  ];

  return (
    <section id="problem" className="py-24 bg-navy-800 border-y border-white/5 relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-6 leading-tight">
            You're losing customers because your online trust is weak.
          </h2>
          <p className="text-xl text-slate-400">
            If your real-world reputation is amazing but your online visibility is weak, weaker competitors are stealing your leads simply because they look more trustworthy to search engines and AI tools.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {problems.map((prob, i) => (
            <motion.div 
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="glass-card rounded-2xl p-8 hover:bg-white/10 transition-colors"
            >
              <div className="w-12 h-12 rounded-xl bg-teal/10 border border-teal/20 flex items-center justify-center mb-6">
                <SafeIcon icon={prob.icon} className="text-teal text-2xl" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">{prob.title}</h3>
              <p className="text-slate-400 leading-relaxed">
                {prob.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Problem;